<template><!-- svgo-optimised -->
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.5 2H4H3V3V13.7793V15L4 14.3L8 11.5L12 14.3L13 15V13.7793V8.5V7H12V8.5V13.0793L8.57346 10.6808L8 10.2793L7.42654 10.6808L4 13.0793V3H8.5V2Z" fill="currentColor"/>
</svg>

</template>